import { http } from '@/utils/http';
import qs from 'qs';
// 初赛前缀
const baseURL = '/vote/2019poject/2019bigfootpre/controller.php?enews=';
// 复赛前缀
const basePrefix = '/vote/2019poject/2019bigfootrem/controller.php?enews=';
// 媒体关注度前缀
const mediaPrefix = 'vote/2019poject/2019bigfootremmt/controller.php?enews=';

/**
 * 未来刀具页面接口
 */

// 活动基本信息
export const baseInfo = () => {
  return http.post(`${baseURL}base-info`);
};

// 获取活动列表
export const getlist = (page: any, search?: any) => {
  return http.post(`${baseURL}vote-list&page=${page}`);
};

// 搜索列表接口
export const searchData = (data: any) => {
  return http.get(`${baseURL}vote-list&search=${data}`);
};

export const getDetail = (id: any) => {
  return http.get(`${baseURL}detail&id=${id}`);
};

export interface ApplyData {
  title: string;
  subtitle: string;
  phone: string;
  cover: string;
  video: string;
}

// 报名
export const apply = (data: ApplyData) => {
  const qsData = qs.stringify(data);
  return http.post(`${baseURL}save`, qsData);
};

// 规则
export const getRules = () => {
  return http.get(`${baseURL}rules`);
};

/**
 * 复赛接口
 */

// 活动基本信息
export const palyoffBaseInfo = () => {
  return http.post(`${basePrefix}base-info`);
};

// 复赛规则
export const palyoffRules = () => {
  return http.get(`${basePrefix}rules`);
};

// 搜索列表接口
export const palyoffSearchData = (data: any) => {
  return http.get(`${basePrefix}vote-list&search=${data}`);
};

// 人气榜和媒体榜列表
export const getPalyoffList = (page: any) => {
  return http.get(`${basePrefix}vote-list&page=${page}`);
};
// 人气投票
export const popularityVote = () => {
  return http.get(`${basePrefix}vote`);
};
// 复赛详情
export const getPalyoDetail = (id: any) => {
  return http.get(`${basePrefix}detail&id=${id}`);
};
/**
 * --------------------------------------------------------媒体榜
 */

// 搜索列表接口
export const mediaSearchData = (data: any) => {
  return http.get(`${mediaPrefix}vote-list&search=${data}`);
};

// 媒体榜列表
export const mediaList = (page: any) => {
  return http.get(`${mediaPrefix}vote-list&page=${page}`);
};

// 复赛详情
export const mediaDetail = (id: any) => {
  return http.get(`${mediaPrefix}detail&id=${id}`);
};


// 媒体投票
export const mediaVote = () => {
  return http.get(`${mediaPrefix}votes`);
};

// 验证是否有媒体排行榜投票权限
export const verifyVotes = () => {
  return http.get(`${mediaPrefix}verify-votes`);
};

// 复赛媒体排行投票
export function votes(
  voteName: string,
  data: {
    id: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  const qsData = qs.stringify(data);
  return http.post(voteName + '/controller.php?enews=votes', qsData);
}
